import { useMediaQuery, useTheme } from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useRef, useState } from 'react';

export const useResponsiveSidebarOpen = (): [
	boolean,
	Dispatch<SetStateAction<boolean>>,
] => {
	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
	const [isSidebarOpen, setIsSidebarOpen] = useState(true);
	const skipNextPersist = useRef(false);

	useEffect(() => {
		skipNextPersist.current = true;
		if (isDesktop) {
			const savedSidebarState = localStorage.getItem('sidebar_open');
			setIsSidebarOpen(
				savedSidebarState === null ? true : savedSidebarState === 'true',
			);
			return;
		}
		setIsSidebarOpen(false);
	}, [isDesktop]);

	useEffect(() => {
		if (!isDesktop) {
			return;
		}
		if (skipNextPersist.current) {
			skipNextPersist.current = false;
			return;
		}
		localStorage.setItem('sidebar_open', isSidebarOpen.toString());
	}, [isSidebarOpen, isDesktop]);

	return [isSidebarOpen, setIsSidebarOpen];
};
